import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { addOutline } from 'ionicons/icons';
import './style.css';
import ModalPopup from '@ui/components/VnModal';
import AddAttachmentsForm from './AddAttachmentsForm';
import { useState } from 'react';
import AttachmentsTable from './AttachmentsTable';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
const AttachmentsTab = ({ formData, errors, onFieldChange, onToggelButtonChange, isAttachmentTabBold }) => {
    const [isOpen, SetIsOpen] = useState(false);
    function oncloseClicked() {
        SetIsOpen(false);
    }
    const handleButtonClick = () => {
        SetIsOpen(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'Vn-supplier-attachments-button', children: _jsx("div", { children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: addOutline, onClick: handleButtonClick, isDisabled: !handleRolePermission(Permission.LEVERANCIERS, PermissionType.Create), children: "Toevoegen Bijlagen" }) }) }), _jsx("div", { className: 'mt-3', children: _jsx(AttachmentsTable, { formData: formData, isAttachmentTabBold: isAttachmentTabBold }) }), _jsx(ModalPopup, { title: 'Upload bestanden', content: _jsx(AddAttachmentsForm, { onClose: oncloseClicked, formData: formData, isAttachmentTabBold: isAttachmentTabBold }), onOpen: isOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' })] }));
};
export default AttachmentsTab;
